// index.js
import React, { useState } from "react";
import ReactDOM from "react-dom/client";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useNavigate,
} from "react-router-dom";

import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { GlobalStateProvider } from "./GlobalStateContext";

import Login from "./Login";
import Register from "./Register";
import VerifyEmail from "./VerifyEmail";
import App from "./App";
import AuthGate from "./AuthGate";

const LoginWrapper = () => {
  const navigate = useNavigate();
  
  const handleLoginSuccess = () => {
    // Force navigation to protected route, which will trigger App.js initialization
    navigate("/", { replace: true });
    // Optional: Force a small delay to ensure navigation completes
    setTimeout(() => {
      window.location.reload();
    }, 100);
  };

  return (
    <Login
      onLoginSuccess={handleLoginSuccess}
      onSwitchToRegister={() => navigate("/register")}
    />
  );
};

const RegisterWrapper = () => {
  const navigate = useNavigate();
  return (
    <Register
      onSwitchToLogin={() => navigate("/login")}
    />
  );
};

const Root = () => (
  <React.StrictMode>
    <GlobalStateProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<LoginWrapper />} />
          <Route path="/register" element={<RegisterWrapper />} />
          <Route path="/verify-email" element={<VerifyEmail />} />

          {/* Protected Routes */}
          <Route
            path="/*"
            element={
              <AuthGate>
                <App />
              </AuthGate>
            }
          />

          {/* Fallback to login */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    </GlobalStateProvider>
  </React.StrictMode>
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Root />);

reportWebVitals();

// // index.js
// import React, { useState } from "react";
// import ReactDOM from "react-dom/client";
// import {
//   BrowserRouter as Router,
//   Routes,
//   Route,
//   Navigate,
//   useNavigate,
// } from "react-router-dom";

// import "./index.css";
// import reportWebVitals from "./reportWebVitals";
// import { GlobalStateProvider } from "./GlobalStateContext";

// import Login from "./Login";
// import Register from "./Register";
// import VerifyEmail from "./VerifyEmail";
// import App from "./App";
// import AuthGate from "./AuthGate";

// const LoginWrapper = () => {
//   const navigate = useNavigate();
//   return (
//     <Login
//       onLoginSuccess={() => navigate("/")}
//       onSwitchToRegister={() => navigate("/register")}
//     />
//   );
// };

// const RegisterWrapper = () => {
//   const navigate = useNavigate();
//   return (
//     <Register
//       onSwitchToLogin={() => navigate("/login")}
//     />
//   );
// };

// const Root = () => (
//   <React.StrictMode>
//     <GlobalStateProvider>
//       <Router>
//         <Routes>
//           {/* Public Routes */}
//           <Route path="/login" element={<LoginWrapper />} />
//           <Route path="/register" element={<RegisterWrapper />} />
//           <Route path="/verify-email" element={<VerifyEmail />} />

//           {/* Protected Routes */}
//           <Route
//             path="/*"
//             element={
//               <AuthGate>
//                 <App />
//               </AuthGate>
//             }
//           />

//           {/* Fallback to login */}
//           <Route path="*" element={<Navigate to="/login" replace />} />
//         </Routes>
//       </Router>
//     </GlobalStateProvider>
//   </React.StrictMode>
// );

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(<Root />);

// reportWebVitals();


